import { render, staticRenderFns } from "./ConArticlePageManagement.vue?vue&type=template&id=807c991e"
import script from "./ConArticlePageManagement.vue?vue&type=script&lang=js"
export * from "./ConArticlePageManagement.vue?vue&type=script&lang=js"
import style0 from "./ConArticlePageManagement.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports